import { Component, OnInit, Input } from '@angular/core';
import { PreChatService } from '../../services/pre-chat.service';
import { Theme } from '../../models/display-setting';

@Component({
  selector: 'app-form-header',
  templateUrl: './form-header.component.html',
  styleUrls: ['./form-header.component.scss']
})
export class FormHeaderComponent implements OnInit {

  @Input() theme: Theme;
  @Input() form;
  resources: any = resources;

  get isTop(): boolean {
		return window.top === window;
	}

  constructor(private preChatService: PreChatService) { }

  ngOnInit() {
  }

  toggleChat(): void {
		this.preChatService.toggleChat();
	}

}
